import "./NursingCaregiverAshdodWithinHours.module.css";
import Header from "@/reusable_sections/Header";
import ResourcesHero from "./sections/ResourcesHero";
import LocationsAndHospitalsInAshdod from "./sections/LocationsAndHospitalsInAshdod";
import DetailedServiceList from "./sections/DetailedServiceList";
import FaqAccordionSection from "./sections/FaqAccordionSection";
import FinalCtaSection from "./sections/FinalCtaSection";
import Footer from "@/reusable_sections/Footer";
export default function NursingCaregiverAshdodWithinHoursPage() {
  return <div>
      <Header />
      <ResourcesHero />
      <LocationsAndHospitalsInAshdod />
      <DetailedServiceList />
      <FaqAccordionSection />
      <FinalCtaSection />
      <Footer />
    </div>;
}